import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthImagePipe } from '../auth-image.pipe';
import { TimeAgoPipe } from 'time-ago-pipe';


@NgModule({
  declarations: [
    AuthImagePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AuthImagePipe
  ]
})

export class PipeModule { }

@Pipe({
    name: 'timeAgo',
    pure: false,
    standalone: false
})
export class TimeAgoExtendsPipePipe extends TimeAgoPipe implements PipeTransform{

  transform(value: string): string {
    return super.transform(value);
  }

}
